import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import hasPermission from '@/utils/utils.js'
import { UserSearch } from '@/models/usersearch.model'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      userSearch: new UserSearch(),
      ordering: ['', 'ASC', 'DESC'],
      endDate: '',
      loading: false,
      permissions: this.$store.state.user.user ? this.$store.state.user.user.permissions : [],
      hasPermission,
      currentPage: this.$route.hash ? this.$route.hash.split('#')[1] : 1,
      perPage: 50,
      totalItems: this.$store.state.user.userListNbResults ? this.$store.state.user.userListNbResults : 0,
      pages: this.$store.state.user.userListNbResults ? Math.ceil(this.$store.state.user.userListNbResults / 50) : 1
    }
  },
  methods: {
    async getUserList (beginIndex) {
      this.initValues()

      this.userSearch.beginIndex = this.perPage * beginIndex
      this.userSearch.endIndex = parseInt(this.userSearch.beginIndex) + this.perPage
      this.loading = true
      this.$store.dispatch('user/getUserList', this.userSearch).then(
        response => {
          this.loading = false
          this.totalItems = this.$store.state.user.userListNbResults
          this.pages = Math.ceil(this.totalItems / this.perPage)

          if (this.pages < 1) {
            this.pages = 1
          }
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    resetForm () {
      this.userSearch = new UserSearch()
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    changeAvailablePage () {
      this.$store.dispatch('user/deleteUserList')

      this.getUserList(this.currentPage - 1)
    },
    initValues () {
      if (!this.userSearch.creationSort) {
        this.userSearch.creationSort = null
      }
      if (!this.userSearch.connexionSort) {
        this.userSearch.connexionSort = null
      }
      if (this.userSearch.entrepriseId === '') {
        this.userSearch.entrepriseId = null
      }
      if (this.userSearch.entity === '') {
        this.userSearch.entity = null
      }
      if (this.userSearch.siret === '') {
        this.userSearch.siret = null
      }
      if (this.userSearch.id === '') {
        this.userSearch.id = null
      }
      if (this.userSearch.login === '') {
        this.userSearch.login = null
      }
      if (this.userSearch.lastName === '') {
        this.userSearch.lastName = null
      }
      if (this.userSearch.firstName === '') {
        this.userSearch.firstName = null
      }
    }
  },
  created () {
    if (!this.$store.state.user.userList.length) {
      this.getUserList(0)
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Liste des utilisateurs'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  },
  mounted () {
    var self = this
    $( function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.userSearch.beginDate = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.userSearch.endDate = dateText
        }
      })
    })
  }
}
